import React from 'react'
import { Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import FrameHeader from '@ms/shared/components/frame/header'

const NotFound = () => {
	const { t } = useTranslation()

	return (
		<>
			<FrameHeader></FrameHeader>
			<Alert variant='info'>{t('common.notFound')}</Alert>
		</>
	)
}

export default NotFound
